export default __webpack_public_path__ + "a947bf020b26ea85daa17dfd2a1a17e902ab18ff/c58a79ed7dc2ca14963e3366521c8d07.png";